var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({background: _vm.backgroundColorDanjuan ? '#EF4B40' : _vm.backgroundColorTencentwm ? '#3662ec' : '#efeff1'}),attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepalive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepalive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5cbc318","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 